import { edmCampaign } from '@bingads-webui/edm-campaign';
import { bulkModelToViewModelForDsaTargetUnderDsaEntity } from './dsa-target';

export const readDsaTargets = (cid, aid, campaignId, adGroupId) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns.$withKey(campaignId)
    .AdGroups.$withKey(adGroupId)
    .DsaTargets
    .get({
      top: 200,
      // Just want to get campaign upgrade status, don't care BI data, so pass dummy date ranges.
      StartDate: '2024-11-14',
      EndDate: '2024-11-14',
    })
    .toPromise();

export const loadDsaTargets = (cid, aid, campaignId, adGroupId) =>
  readDsaTargets(cid, aid, campaignId, adGroupId)
    .then((result) => {
      const data = bulkModelToViewModelForDsaTargetUnderDsaEntity(result && result.value);

      return data;
    });
